import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CourseShort } from '../../models/course-short.model';
import { FranchiseCourse } from '../../models/franchise-course.model';
import { Course } from '../../models/course.model';

@Component({
    selector: 'card-course',
    templateUrl: './card-course.component.html',
    styleUrls: ['./card-course.component.scss']
})
export class CardCourseComponent implements OnInit {
    course: Course = new Course;

    @Input('course')
    set courseValue(val: Course|FranchiseCourse|CourseShort|undefined) {
        if (this.course !== val) {
             if (val instanceof Course) {
                this.course = Course.fromJson(val);
                this.course.id = val.id;
            } else if (val instanceof CourseShort) {
                this.course = Course.fromJson(val);
            } else if (val instanceof FranchiseCourse) {
                this.course = Course.fromJson(val?.course);
                this.course.id = val.id;
            }
        }
    }
    get courseValue(): Course|undefined {
        return this.course ?? undefined;
    }

    @Input() pageUrl: string = ''; // '/courses/';

    constructor(
        protected router: Router,
    ) { }

    ngOnInit(): void { }

    preventPropagation(event?: MouseEvent): boolean {
        event?.stopPropagation();
        return true;
    }

}
